import Ollie from './players/80936-Olli Simonsen.json';
import Jack from './players/145098-Jack Smith.json';
import Mole from './players/145431-Martin Mole Colbert.json';
// import Mike from './players/145507-Mike Grimwade.json';
import Ryan from './players/145741-Ryan Gardner.json';
// import Amie from './players/173603-Amie Gardner.json';
import Matt from './players/175731-Matthew Van Schalkwyk.json';
// import Kelly from './players/177258-Kelly Sharples.json';
import Adrian from './players/177268-Adrian Sharples.json';
import James from './players/185296-James Hanley.json';
// import Ciaran from './players/193481-Ciaran Buckley.json';
import Max from './players/194115-Maximilian Berkmann.json';
// import Freddie from './players/203157-Freddie Ferrari.json';
// import Kimbo from './players/234831-Kimberly Unsworth.json';
// import Dean from './players/245825-Dean Smith.json';

const LdgcTeam = [Ollie, Jack, Mole, Ryan, Matt, Adrian, James, Max];

export default LdgcTeam;
